import { COUPON_REPORT, POS_PROVIDER } from './constants';

// POS is offered on every report type, but only the coupon report starts with
// it selected.
export const isPosSelectedByDefault = (type) => type === COUPON_REPORT;

export const getDefaultSelectedProviders = (providers, type) => {
  const providerNames = Object.keys(providers);
  if (isPosSelectedByDefault(type)) {
    return providerNames;
  }
  return providerNames.filter((provider) => provider !== POS_PROVIDER);
};

export const hasPosProvider = (providers) =>
  Object.keys(providers).includes(POS_PROVIDER);

// When a saved filter is picked from the report type dropdown, `model.type`
// holds the saved filter label instead of the report type, so the type has to
// be read from the saved filter itself.
export const getEffectiveReportType = (modelType, currentFilter) =>
  currentFilter?.data?.type ?? modelType;

export const applyPosProviderForType = (model, type, posAvailable) => {
  const providers = model.providers;

  if (
    !isPosSelectedByDefault(type) ||
    !posAvailable ||
    providers.includes(POS_PROVIDER)
  ) {
    return model;
  }
  return { ...model, providers: [...providers, POS_PROVIDER] };
};
